module.exports = __webpack_public_path__ + "static/woman_veil-b4f2dc139c7fe79cf8c93d6da116b9a3.png";